import { Controller } from "@hotwired/stimulus"

// Модалка генерации фото на манекене + поллинг статусов.
export default class extends Controller {
  static targets = ["modal", "color", "garment", "mannequin", "tiles"]

  open(event) {
    const b = event.currentTarget
    this.designId = b.dataset.mannequinDesignId
    this.colorTarget.value = this.#hex(b.dataset.mannequinColor)
    this.garmentTarget.value = b.dataset.mannequinGarment || "футболка"
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
  }

  async generate() {
    const body = { color: this.colorTarget.value, garment: this.garmentTarget.value, mannequin: this.mannequinTarget.value }
    this.close()
    this.#showTiles([])
    const res = await fetch(`/designs/${this.designId}/mannequin_shots`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrf() },
      body: JSON.stringify(body)
    })
    const data = await res.json()
    this.#render(data.shots)
    this.#poll()
  }

  #poll() {
    clearTimeout(this._t)
    this._t = setTimeout(async () => {
      const res = await fetch(`/designs/${this.designId}/mannequin_shots`, { headers: { Accept: "application/json" } })
      const data = await res.json()
      this.#render(data.shots)
      if (data.shots.some((s) => s.status === "pending")) this.#poll()
    }, 3000)
  }

  #showTiles() {
    this.tilesTarget.classList.remove("hidden")
    this.tilesTarget.classList.add("grid")
  }

  #render(shots) {
    const label = { front: "Спереди", back: "Сзади" }
    this.tilesTarget.innerHTML = shots.map((s) => {
      let inner
      if (s.status === "done") {
        const badge = s.ai === false ? `<span class="absolute left-1 top-1 rounded bg-black/60 px-1 text-[10px] text-white">без ИИ</span>` : ""
        inner = `<div class="relative"><img src="${this.#esc(s.image_url)}" class="w-full rounded-lg border border-gray-200"/>${badge}</div>`
      } else if (s.status === "failed") {
        inner = `<div class="rounded-lg border border-red-200 bg-red-50 p-3 text-xs text-red-700">Ошибка: ${this.#esc(s.error || "—")}</div>`
      } else {
        inner = `<div class="flex h-40 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-sm text-brand-muted">Генерация…</div>`
      }
      return `<div><div class="mb-1 text-xs font-semibold text-brand-muted">${label[s.view] || this.#esc(s.view)}</div>${inner}</div>`
    }).join("")
  }

  #esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))
  }

  #hex(v) { return /^#[0-9a-fA-F]{6}$/.test(v || "") ? v : "#ffffff" }
  #csrf() { return document.querySelector('meta[name="csrf-token"]')?.content || "" }
}
